<!--  -->
<template>
  <div class="certification">
    <div class="tiltle">企业信息</div>
    <!-- <el-radio-group v-model="radio1">
      <el-radio-button label="企业认证"></el-radio-button>
      <el-radio-button label="荣誉证书"></el-radio-button>
    </el-radio-group> -->
    <div class="gallery">
      <div
        v-for="(certificate, index) in certificates"
        :key="index"
        class="certificate-item"
      >
        <el-image :src="certificate.url" :preview-src-list="srcList">
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      radio1: "企业认证",
      srcList: [],
      certificates: [
        { url: require("@/assets/Frame483.png"), name: "证书1" },
        { url: require("@/assets/Frame484.png"), name: "证书1" },
        { url: require("@/assets/Frame480.png"), name: "证书1" },
        { url: require("@/assets/Frame481.png"), name: "证书1" },
        { url: require("@/assets/Frame482.png"), name: "证书1" },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.srcList = this.certificates.map((item) => item.url);
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.certification {
  padding: 80px 360px;
  .tiltle {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
    margin-bottom: 20px;
  }
}
.gallery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 72px;
  .certificate-item {
    img {
      width: 192px;
      height: 274px;
    }
  }
}
</style>
